import {useEffect, useState} from "react";

const initialResponse = {
    error: false,
    jsonMap: null
}

export const useWorldMap = lowRes => {
    const [response, setResponse] = useState(initialResponse);

    const baseUrl = "https://d386jdxc97m0w5.cloudfront.net"
    useEffect(() => {
        const url = `${baseUrl}/${lowRes ? "world-low-res.json": "world.json"}`
        fetch(url)
            .then(response => {
                if(response.ok) {
                    return response.json();
                } else {
                    return Promise.reject(response.status);
                }
            })
            .then(json => setResponse({
                error: false,
                jsonMap: json
            }))
            .catch(error => {
                console.error(error)
                setResponse({
                    error: true,
                    jsonMap: null
                })
            })
    },[lowRes])

    return response
}